import {
  checkpointDefinitionsArray,
  optionsCheckpoint
} from "@modules/JourneyBuilder/Bricks/checkpoint-definitions";

const removeCheckpointSupport = (connection, checkpoint) => {
  const index = connection.supportedCheckpoints.indexOf(checkpoint.name);
  if(index !== -1) {
    connection.supportedCheckpoints.splice(
      index,
      1
    ); 
  }
}

/**
 * Initialize the given goal brick
 * @param {JourneyBrick} brick
 */
const initialize = brick => {
  const _registerConnection = brick.registerConnection;
  brick.registerConnection = function(connection) {
    _registerConnection.apply(this, arguments);

    //https://datanext.atlassian.net/browse/DPN-3199
    //Goal brick connections only accept options checkpoints
    checkpointDefinitionsArray.forEach(checkpoint => {
      if(checkpoint.name !== optionsCheckpoint.name) {
        removeCheckpointSupport(connection, checkpoint);
      }
    });
  }
}

export {initialize};